import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 10,
	viewBox: "0 0 10 10",
	width: 10,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("path", { d: "m1 9 8-8" }), /* @__PURE__ */ _jsx("path", { d: "m9 9-8-8" })]
	})
});
export default SvgCross;
